import { Component, EventEmitter, Input, OnInit, Output, ViewChildren, booleanAttribute } from "@angular/core";
import { DateService } from "@root/shared/service/date.service";
import * as moment from "moment";
import _, { range } from "lodash";
import { PlatformType } from "@root/config";
import { RulesSettingsService } from "../rules-settings/rules-settings.service";
import { PriceChild } from "../../calendar/multi-house-calendar/multi-house-calendar.service";
import { CacheService } from "@delon/cache";
import { TranslateService } from "@root/shared/service/translate.service";
import { ModalService } from "@root/router/index/modal.service";
import { Field } from "@root/router/price/batch-modify-restrictions/batch-modify-restrictions.service";

// export type Field =
//   | "mixed"
//   | "min_stay_through"
//   | "max_stay_through"
//   | "min_stay_on_arrival"
//   | "max_stay_on_arrival"
//   | "exact_stay_on_arrival"
//   | "min_advance_reservation"
//   | "max_advance_reservation"
//   | "closed_on_arrival"
//   | "closed_on_departure"
//   | "rule_id";

@Component({
  selector: "os-price-rules-setting",
  templateUrl: "./price-rules-setting.component.html",
  styleUrls: ["./price-rules-setting.component.scss"],
})
export class OSPriceRulesSettingComponent implements OnInit {
  readonly Platform: typeof PlatformType = PlatformType;
  @ViewChildren("rulesSettingsForm") widgetRulesSettingsForm;
  @Input() dateRange: Array<string | Date> = [];
  @Input() listOfHouse = [];
  @Input() entity: PriceChild;
  @Output() success = new EventEmitter();
  @Output() onUpdated = new EventEmitter();
  readonly filterOpts = [
    "mixed",
    "min_stay_on_arrival",
    "max_stay_on_arrival",
    "min_stay_through",
    "max_stay_through",
    "exact_stay_on_arrival",
    "min_advance_reservation",
    "max_advance_reservation",
    "closed_on_arrival",
    "closed_on_departure",
    "rule_id",
  ].map((key) => ({
    label: this.t.t("channel-sidebar_rules_html_opt_" + key),
    value: key,
  }));
  quickEditValue;
  quickEditDaysValue;
  quickEditHoursValue;
  filterMode: Field = this.getLocalFilterMode() || "mixed";
  loading = false;
  nzFormat = this.dateService.getAngularFormat(["YMD"]);
  optionsOfMARHours = [{ label: "Reset", value: null }, ...range(0, 24).map((i) => ({ label: `${i}`, value: i }))];
  disabledDate = (date: string | Date) => {
    const head = moment().subtract(1, "d");
    const last = moment().add(2, "year");

    return !moment(date).isBetween(head, last, "d");
  };
  get nights() {
    const head = moment(_.head(this.dateRange));
    const last = moment(_.last(this.dateRange));
    return last.diff(head, "days") + 1;
  }
  constructor(
    private dateService: DateService,
    private rsSrv: RulesSettingsService,
    private cache: CacheService,
    private t: TranslateService,
    private modal: ModalService,
  ) {}

  ngOnInit() {
    console.log("filter opts: ", this.filterOpts);

    this.listOfHouse.forEach((house) => {
      if (house.unique_key === this.entity.c_id) {
        house.unfold = true;
      }
    });
  }

  private getLocalFilterMode(): Field {
    return this.cache.getNone("hostex.price.channel_price.filter_mode");
  }

  private setLocalFilterMode(mode: Field) {
    this.cache.set("hostex.price.channel_price.filter_mode", mode);
  }

  onFilterModeChange(mode: Field) {
    this.setLocalFilterMode(mode);

    this.quickEditValue = null;
  }

  onClickCancel() {
    this.success.emit();
  }

  onQuickEdit(type: "select" | "checkbox" | "input") {
    console.log("this.list: ", this.widgetRulesSettingsForm.toArray());
    const forms = this.widgetRulesSettingsForm.toArray();
    forms.forEach((form) => {
      console.log("form.form.value: ", form.form.value, " this.quickEditValue: ", this.quickEditValue);
      if (type === "select") {
        if (this.filterMode === "min_advance_reservation") {
          if (!form.minARDays.disabled) {
            form.minARDays.setValue(this.quickEditDaysValue);
            form.minARHours.setValue(this.quickEditHoursValue);
          }
        } else {
          if (!form.maxARDays.disabled) {
            form.maxARDays.setValue(this.quickEditDaysValue);
          }
        }
      } else {
        if (!form.form.get([this.filterMode]).disabled) {
          form.form.patchValue({ [this.filterMode]: this.quickEditValue });
        }
      }
    });
  }

  onDisplayListingPr() {
    if (this.entity.house_type_price_id) {
      this.modal.displayRoomTypeDetailDrawer(this.entity.c_parent.p_id, 2);
    } else {
      this.modal.displayPropertyDetailDrawer(this.entity.c_id, 2);
    }
    // const house = this.listOfHouse.find((house) => house.unique_key === this.entity.c_id);
    // console.log("enteity: ", this.entity, " list of house: ", house);
  }

  onClickSave() {
    this.rsSrv.save();
  }

  onFormSaved(hideLoading) {
    this.loading = hideLoading;
    this.onUpdated.emit();
  }
}
